import { OembedProviderInterface } from './oembed.provider.interface';

export class YoutubeProvider extends OembedProviderInterface {
  name = 'youtube';
  urls = [
    /^(?:m\.)?youtube\.com\/watch\?v=([\w-]+)/,
    /^(?:m\.)?youtube\.com\/v\/([\w-]+)/,
    /^youtube\.com\/embed\/([\w-]+)/,
    /^youtu\.be\/([\w-]+)/,
  ];

  getVideo(id: string): string {
    return (
      '<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;">' +
      `<iframe src="https://www.youtube.com/embed/${id}" ` +
      'style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" ' +
      'frameborder="0" allow="autoplay; encrypted-media" allowfullscreen>' +
      '</iframe>' +
      '</div>'
    );
  }
}
